'use strict';
/* jshint ignore:start */
var account = {
		addNewAddressEvent: function (e) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'Add New Address'
			};
			$.extend(obj, getContactPreferencesFromProfile());
			dataLayer.push(obj);
		},

		removeAddressEvent: function (e) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'Remove Address'
			};
			$.extend(obj, getContactPreferencesFromProfile());
			dataLayer.push(obj);
		},

		contactPreferencesEvent: function (e) {
			var obj = {
					button_ID: e.target.id ? e.target.id : e.target.innerText,
					event: 'Contact Preferences'
			};
			$.extend(obj, getContactPreferences());
			$.extend(obj, getContactSettings());
			$.extend(obj, getContactData());
			dataLayer.push(obj);

			var requestCatalog = $('#dwfrm_contactprefs_profile_contactPreferencesCatalogue').prop('checked');
			if (requestCatalog) {
				// catalogueRequest event
				if ($('input[name=customerData]').length > 0) {
					var customer = JSON.parse($('input[name=customerData]').val());
					// object to be pushed
					var obj = {
						button_ID: e.target.id ? e.target.id : e.target.innerText,
						event: 'catalogueRequest'
					};
					$.extend(obj, getCustomerData());
					dataLayer.push(obj);
				}
			}
		},

		savedCardsAddNewEvent: function (e) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'Saved cards - add new card',
				customer_contact_preferences: getContactPreferences(),
				paymanet_save_card: 'yes'
			};
			$.extend(obj, getContactData());
			dataLayer.push(obj);
		},

		savedCardsRemoveCardEvent: function (e) {
			if ($('input[name=profileData]').length == 0) {
				return;
			}
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'Saved cards - remove card'
			};
			$.extend(obj, getContactPreferencesFromProfile());
			dataLayer.push(obj);
		},

		unsubscribeFromAllEvent: function (e) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'Unsubscribe from all'
			};
			$.extend(obj, getContactPreferences());
			dataLayer.push(obj);
		},

		scoreProductEvent: function (e) {
			var obj = {
				event: 'HC score products/reviews'
			};
			dataLayer.push(obj);
		}
}

/**
 * Returns an object which contains contact preferencesa
 *
 * @returns Object
 */
function getContactPreferences() {

	var preferences = '';
	$('.related-to-attributes input[type=checkbox]').each(function () {
		if ($(this).prop('checked')) {
			var label = $("label[for='" + $(this).attr('id') + "']");
			if (preferences === '') {
				preferences =  label.text().trim();
			} else {
				preferences += ' | ' + label.text().trim();
			}
		}
	});

	// object to be pushed
	var obj = {
		'customer_contact_preferences': preferences
	};
	return obj;

}

function getContactSettings() {

	var preferences = '';

	$('.send-me-attributes input[type=checkbox]').each(function () {
		if ($(this).prop('checked')) {
			var label = $("label[for='" + $(this).attr('id') + "']");
			if (preferences === '') {
				preferences =  label.text().trim();
			} else {
				preferences += ' | ' + label.text().trim();
			}
		}
	});

	// object to be pushed
	var obj = {
		'customer_contact_settings': preferences
	};
	return obj;

}

function getContactPreferencesFromProfile() {
	var profileObject = JSON.parse($('input[name=profileData]').val());
	// object to be pushed
	var obj = {
		'customer_contact_preferences': profileObject.customer_contact_preferences
	}
	return obj;
}

function getProfileData() {
	if ($('input[name=profileData]').length > 0) {
		var profileObject = JSON.parse($('input[name=profileData]').val());
		// object to be pushed
		var obj = {
			're_dairy_allergy': profileObject.re_dairy_allergy,
			're_favourite_chocolate_type': profileObject.re_favourite_chocolate_type,
			're_first_name': profileObject.re_first_name,
			're_gluten_allergy': profileObject.re_gluten_allergy,
			're_last_name': profileObject.re_last_name,
			're_nut_allergy':  profileObject.re_nut_allergy,
			're_soya_allergy': profileObject.re_soya_allergy,
			're_vegans': profileObject.re_vegans,
			're_vegetarians': profileObject.re_vegetarians,
			're_wheat_allergy': profileObject.re_wheat_allergy
		};
		return obj;
	}
}

function getContactData() {
	if ($('input[name=profileData]').length > 0) {
		var profileObject = JSON.parse($('input[name=profileData]').val());
		// object to be pushed
		var obj = {
			're_3rd_party_permit': profileObject.re_3rd_party_permit,
			're_account_locked': profileObject.re_account_locked
		};
		return obj;
	}
}

function getCustomerData() {
	if ($('input[name=customerData]').length > 0) {
		var customer = JSON.parse($('input[name=customerData]').val());
		// object to be pushed
		var obj = {
				're_3rd_party_permit': $('input[name$=_contactPreferencesAllowMailshot]').prop('checked') === true ? 'yes' : 'no',
				're_address1': customer.re_address1,
				're_address2': customer.re_address2,
				're_company_name': customer.re_company_name,
				're_country': customer.re_country,
				're_email_address': customer.re_email_address,
				're_email_permit': $('input[name$=_contactPreferencesAllowMail]').prop('checked') === true ? 'yes' : 'no',
				're_first_name': customer.re_first_name,
				're_last_name': customer.re_last_name,
				're_job_title': customer.re_job_title,
				're_mobile_number': customer.re_mobile_number,
				're_postcode': customer.re_postcode,
				're_sms_optout': $('input[name$=_contactPreferencesAllowSMS]').prop('checked') === true ? 'yes' : 'no'
			};
		return obj;
	}
}
module.exports = account
/* jshint ignore:end */
